/**
 * ChatMessageDeleteReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ChatMessageDeleteReq
 */
export interface ChatMessageDeleteReq {
  /** 消息ID */
  id: string
}

/**
 * ChatMessageDeleteReq Schema
 */
export const ChatMessageDeleteReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '消息ID',
      format: 'string',
      type: 'string',
      label: '消息ID',
    },
  },
  required: ['id'],
  type: 'object',
}
